import { TitleCasePipe } from '@angular/common';
import { UserType } from '../enums/user-type.enum';
import { keyBy } from 'lodash-es';

export class UserTypeOption {
  constructor(public value: string, public display: string) {}
}

export const userTypeOptions = [
  new UserTypeOption(UserType.unknown, "Unknown"),
  new UserTypeOption(UserType.captureAdmin, "Capture Admin"),
  new UserTypeOption(UserType.cePortal, "CE Portal"),
  new UserTypeOption(UserType.cePortalConsultant, "CE Portal Consultant"),
  new UserTypeOption(UserType.cePortalInternalConsultant, "CE Portal Internal Consultant"),
  new UserTypeOption(UserType.partnerPortal, "Partner Portal"),
  new UserTypeOption(UserType.llmPlaygroundUser, "LLM Playground User"),
];

export const keyedUserTypeOptions = keyBy(userTypeOptions, 'value');

export const displayUserType = (value: any, _args?: any): any => {
  if (value) {
    value = value.replace(new RegExp('_', 'g'), ' ');
    value = new TitleCasePipe().transform(value);
    return value.replace('Ce', 'CE');
  } else {
    return value;
  }
}
